import { Outlet } from 'react-router-dom';

const Registration = () => {
  return <Outlet />;
};

export default Registration;
